const  Menu = require('../home/menu')

module.exports = function () {
  Menu()

  // Sticky header effect
  const $page_header =   $('#page-header')

  const $page_content = $('#page-content')
  if ($page_content.length) {
    new Waypoint({
      element: $page_content,
      handler: function(direction) {
        if(direction === 'down'){
          $page_header.addClass('fixed');
        }
      },
      offset: 160
    })
  }

  if ($page_header.length) {
    new Waypoint({
      element: $page_header,
      handler: function(direction) {
        if(direction === 'up'){
          $page_header.removeClass('fixed');
        }
      },
      offset: -1
    })
  }
}
